import i18n, {type TFunction} from "i18next";
import {initReactI18next} from "react-i18next";
import enUI from './en/ui.json';
import enException from './en/exception.json';

import koUI from './ko/ui.json';
import koException from './ko/exception.json';
import LanguageDetector from 'i18next-browser-languagedetector';


i18n.use(LanguageDetector).use(initReactI18next).init({
    detection: {
        // https://github.com/i18next/i18next-browser-languageDetector?tab=readme-ov-file#detector-options
        // order and from where user language should be detected
        order: [ 'cookie', 'localStorage', 'sessionStorage', 'navigator', ],

        // keys or params to lookup language from
        lookupCookie: 'lang',
        lookupLocalStorage: 'lang',
        lookupSessionStorage: 'lang',

        // cache user language on
        caches: ['localStorage', 'cookie'],
        excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
    },

    resources: {
        en: {
            ui: enUI,
            exception: enException
        },
        ko: {
            ui: koUI,
            exception: koException
        },
    },
    ns: ['ui', 'exception'],
    defaultNS: 'ui',            // 기본 namespace
    keySeparator: ".",
    lng: i18n.language,
    fallbackLng: "ko",
    interpolation: {
        escapeValue: false,
    },
}).catch(err => console.error(err));


export function initExceptionLocalization(t: TFunction<'exception', undefined>) {
    et = t;
}

document.documentElement.lang=i18n.language;
export let et: TFunction<"exception", undefined>;
// && i18n.changeLanguage(Cookies.get("lang") || "ko");